var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-ex" }, [
    _vm._m(0),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
    _vm._m(4),
    _c("p", { staticStyle: { "text-indent": "27.7pt" } }),
    _c("br"),
    _c("p", { staticStyle: { "text-indent": "24.1pt" } }, [
      _vm._v(" 被授权方："),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.user_company))])
        : _vm._e(),
      _vm._v("（以下简称乙方） ")
    ]),
    _c("p", { staticStyle: { "text-indent": "23.7pt" } }, [
      _vm._v(" 营业地址： "),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.user_business_address))])
        : _vm._e()
    ]),
    _c("p", { staticStyle: { "text-indent": "23.55pt" } }, [
      _vm._v(" 法定代表人："),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.user_legal_person))])
        : _vm._e()
    ]),
    _c("p", { staticStyle: { "text-indent": "23.55pt" } }, [
      _vm._v(" 经营者身份证号码："),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.userInfo.card_id))])
        : _vm._e()
    ]),
    _c("p", { staticStyle: { "text-indent": "23.7pt" } }, [
      _vm._v(" 电话： "),
      _c("u", [_vm._v(_vm._s(_vm.company.userInfo.phone))])
    ]),
    _c("br"),
    _vm._m(5),
    _vm._m(6),
    _vm._m(7),
    _vm._m(8),
    _c("p", { staticStyle: { "text-indent": "27.7pt" } }, [
      _vm._v(
        "1、本合同甲、乙双方为各自独立的自然人、法人或非法人组织，具有全完独立自主的民事行为能力，能够独自行使权利、履行义务、承担责任。"
      )
    ]),
    _c("p", { staticStyle: { "text-indent": "27.7pt" } }, [
      _vm._v(
        " 2、乙方是甲方的授权经销商，经过了市场监督管理局的合法登记注册，不是甲方的分支机构或代理人，不得以受托人或任何身份，从事包括但不限于代表甲方发表、签署任何声明、文件或承诺承担任何法律责任等行为。乙方职工不是甲方的员工，甲方对其劳动关系及员工行为不承担任何责任。 "
      )
    ]),
    _c("p", { staticStyle: { "text-indent": "27.7pt" } }, [
      _vm._v(
        "3、乙方的经营在遵守甲方有关规定的前提下自行决策，独立承担经济、法律责任，实行独立核算、自主经营、自负盈亏，其经营决策是乙方自行判断、自主运作的行为。"
      )
    ]),
    _vm._m(9),
    _vm._m(10),
    _vm._m(11),
    _vm._m(12),
    _vm._m(13),
    _vm._m(14),
    _vm._m(15),
    _vm._m(16),
    _vm._m(17),
    _vm._m(18),
    _vm._m(19),
    _vm._m(20),
    _vm._m(21),
    _vm._m(22),
    _vm._m(23),
    _vm._m(24),
    _vm._m(25),
    _vm._m(26),
    _vm._m(27),
    _vm._m(28),
    _vm._m(29),
    _vm._m(30),
    _vm._m(31),
    _vm._m(32),
    _vm._m(33),
    _vm._m(34),
    _vm._m(35),
    _vm._m(36),
    _vm._m(37),
    _vm._m(38),
    _vm._m(39),
    _vm._m(40),
    _vm._m(41),
    _vm._m(42),
    _vm._m(43),
    _vm._m(44),
    _vm._m(45),
    _vm._m(46),
    _vm._m(47),
    _vm._m(48),
    _vm._m(49),
    _vm._m(50),
    _vm._m(51),
    _vm._m(52),
    _vm._m(53),
    _vm._m(54),
    _vm._m(55),
    _vm._m(56),
    _vm._m(57),
    _vm._m(58),
    _vm._m(59),
    _vm._m(60),
    _vm._m(61),
    _vm._m(62),
    _vm._m(63),
    _vm._m(64),
    _vm._m(65),
    _vm._m(66),
    _vm._m(67),
    _vm._m(68),
    _vm._m(69),
    _vm._m(70),
    _vm._m(71),
    _vm._m(72),
    _vm._m(73),
    _vm._m(74),
    _c("p", { staticStyle: { "text-indent": "24pt" } }, [
      _vm._v("1、本人已仔细阅读合同条款，充分了解合同内容；")
    ]),
    _c("p", { staticStyle: { "text-indent": "24pt" } }, [
      _vm._v("2、本人已交付的定金不得以任何理由要求甲方退还；")
    ]),
    _vm._m(75),
    _vm._m(76),
    _vm._m(77),
    _vm._m(78),
    _vm._m(79),
    _vm._m(80),
    _vm._m(81),
    _vm._m(82),
    _vm._m(83),
    _vm._m(84),
    _vm._m(85),
    _vm._m(86),
    _vm._m(87),
    _c("p", [_vm._v("甲方（签字或盖章）： 乙方（签字或盖章）： ")]),
    _c("p"),
    _c("p"),
    _vm._m(88),
    _vm._m(89),
    _vm._m(90),
    _vm._m(91),
    _vm._m(92),
    _vm._m(93)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "center" } }, [
      _c("strong", [_vm._v("产品代理合同")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "justify" } }, [
      _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "24pt" } }, [
      _vm._v(" 授权方："),
      _c("u", [_vm._v(" 大连景盛铭泰商贸有限公司 ")]),
      _vm._v("（以下简称甲方） ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "22.8pt" } }, [
      _vm._v(" 法定代表人："),
      _c("u", [_vm._v(" 许兆旻 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "22.8pt" } }, [
      _vm._v(" 注册地址："),
      _c("u", [_vm._v(" 辽宁省大连保税区自贸大厦816室 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "为明确双方在产品授权经销上的权利义务关系，甲、乙双方本着自愿、平等、诚实、守信的原则，经友好协商，就乙方作为甲方“销售代理”，推广销售甲方指定桃花养元汤、桃花固元汤、龙颜大悦奶茶等系列产品达成以下协议，代理期限为24个月。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "27.75pt" } }, [
      _c("strong", [_vm._v("第一条 双方声明")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第二条 代理商待遇和销售奖励")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、本协议签订后，乙方成为甲方代理商，享有甲方采购产品并销售的资格。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("2、乙方自愿成为甲方一品")
        ]),
        _c("u", [_vm._v("高达")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("代理商，并承担相应销售责任。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("一品高达代理商，一次性采购货量达到")
        ]),
        _c("u", [_vm._v("1000")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("盒，可享受基准价格")
        ]),
        _c("u", [_vm._v("300")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("元/盒（大写：叁佰元）进行采购，即总货款30万元。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "如乙方资金紧张但有符合经营范围的营业执照，可选择与甲方签约，先支付10%货款定金方式，取得一品高达代理商资格。即：每盒向公司支付30元/盒定金，总计1000盒的定金1.5万元至3万元（定金不予以退回）。之后每次向公司提货补270元/盒差价，即可每次订货量为10盒的整倍数向甲方提货。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("3、进货返点奖励：")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("累计销售产品数量达到")
        ]),
        _c("u", [_vm._v("1.2")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("万盒，每盒返还")
        ]),
        _c("u", [_vm._v("3")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("元,做为奖励;")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("累计销售产品数量达到")
        ]),
        _c("u", [_vm._v("2.4")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("万盒，每盒返还")
        ]),
        _c("u", [_vm._v("6")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("元,做为奖励；")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("累计销售产品数量达到")
        ]),
        _c("u", [_vm._v("4")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("万盒，每盒返还")
        ]),
        _c("u", [_vm._v("9")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("元,做为奖励；")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("累计销售产品数量达到")
        ]),
        _c("u", [_vm._v("12")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("万盒，每盒返还")
        ]),
        _c("u", [_vm._v("12")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("元,做为奖励；")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("累计销售产品数量达到")
        ]),
        _c("u", [_vm._v("40")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("万盒，每盒返还")
        ]),
        _c("u", [_vm._v("15")]),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("元,做为奖励；")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "justify" } }, [
      _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
        _vm._v(" 4、乙方可以用乙方的名义给其他经销商进行批发和零售。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第三条 结算及运输")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、甲方采用先收款、后发货的结算方式，乙方定购的货物可以自提，也可以由甲方代为储存、代为发货，代为储存时间限合同签定日期起16个月内。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、由甲方代为储存、发货的，双方可以另行签订“代存储、发货协议”，甲方按照乙方或乙方客户的要求，分批次将货物发送至指定地点，但每次发运量必须为10盒的整数倍。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "3、乙方将订单和汇款凭证一同扫描发送到甲方，甲方确认到账后，以乙方订单为准在5日内进行发货。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "4、甲方根据乙方的订单发货，运费由甲方承担，但如因乙方填写地址不详、无人收货等原因造成的二次运费由乙方承担。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "5、当甲、乙双方终止合作或乙方订购甲方其他种类产品时，乙方已交付的定金和货款不能退还，已订购产品不能向甲方申请退货，可以一次性补齐货款将货提走。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "6、乙方交付的定金，已经作为甲方投入运营的必要费用，无论乙方是否实际采购，均不得要求甲方退还。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("7、甲方收款账户为：")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("单位名称：大连景盛铭泰商贸有限公司")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("税号：91210242MA7NDT7K99")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("地址：辽宁省大连保税区自贸大厦816室")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("开户银行：")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("账户：")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("乙方向上述账户付款后，即视为履行了付款义务。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第四条 甲方的权利和义务")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("1、甲方授权给乙方指定产品的推广销售工作。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、甲方尽可能详尽的给乙方提供公司证件、产品检验证件和宣传资料。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "3、乙方所有线上交易平台销售的产品必须严格按照规定的零售价执行，若因特殊促销价格折扣不得低于甲方提供的促销价，否则停止供货，取消代理资格，已经缴纳的定金、预付款不予退还，并承担相应的经济赔偿。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "4、为规范市场，甲方有权利对乙方是否正确推广产品及乱价销售进行监督，预防破坏整体市场。"
          )
        ]),
        _c("strong")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第五条 乙方的权利和义务")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、乙方合约仓的1000盒货物，必须自交付定金之日起16个月内销售完毕，否则定金作废，也可以在一个月内一次性补齐货款将货提走。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、乙方须遵守甲方经销商管理有关规定，对甲方、产品和业务推广承担以下责任："
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（1）乙方须按甲方的指导价格，明码实价出售产品，不得有削价或变相削价等不正当行为；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（2）乙方同意向甲方交付的定金可以抵减购货款，但不得要求返还；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（3）对顾客购买的产品，乙方应对产品标签上所标明的使用方法及注意事项进行说明；不得对公司或其产品做出任何虚假宣传、夸大或无根据的宣传，不得以误导的方式进行解释；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("（4）不得贬低、攻击、诋毁本公司或其他公司及其品牌、商品；")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（5）不得将任何非甲方产品或服务伪称甲方产品或服务加以推广，不得从事竞争企业之产品或服务的推广；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（6）认真学习、了解产品情况，实事求是的介绍产品，不得散布任何未经甲方认可的业务、政策、营运等信息，或对产品信息作失实宣导；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（7）不得在业务推广过程中，涉及宗教、传销、政治、迷信、不道德或其他非商业性话题；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（8）不可进行不正当竞争，不正当竞争包括但不限于拉帮结派、恶意降价，扰乱正常的业务秩序；"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "（9）不得弄虚作假、盲目囤货或以诱导、欺骗等不正当方式让消费者大量囤货，人为操纵销售业绩、破坏市场秩序。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "3、乙方须认真遵守业务辅销资料政策，仅可使用甲方认可的文字、录音、影像资料，辅助公司产品销售；否则，产生的一切法律责任与公司无关，由乙方承担，因此造成甲方损失的，应当由乙方承担。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "4、甲方在接到相关投诉进行调查取证时，乙方不得提供不实资料，对甲方调查造成干扰。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "5、乙方应以其真实身份对外开展工作，不得利用甲方及其甲方关联方的名义与任何组织和个人订立合同；也不得以其它会侵害甲方权益的方式拓展市场。否则乙方应赔偿因此给甲方造成的全部损失。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第七条 保密条款")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、在授权期内，甲方交付乙方使用的所有设备及技术、手册、授权经营资料等，乙方无权另行转让。在合作结束时，乙方应将甲方提供给乙方的设备、资料、文件、手册、授权经营资料及其他扶持品全部返还给甲方。若乙方擅自处置甲方提供的设备、资料、文件、手册、授权经营资料、扶持品等而造成损失的，乙方负责赔偿，同时甲方保留进一步追究乙方责任的权利。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、在授权期内，对甲方提供给乙方的任何资料、文件及尚未公布的经营计划，促销方案等，乙方有义务为甲方保密，不经甲方书面允许，乙方不得向任何第三方泄漏，因泄露给甲方造成损失的，由乙方负责赔偿。该条款约定不受合同期限的限制，合同的终止、解除或无效不影响该条款的效力。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "3、在授权期内，乙方违反本协议规定或侵犯甲方利益，甲方有权随时取消乙方产品代理资格，终止本合同并不承担任何责任。而由此给甲方造成损失的，甲方有权向乙方追偿。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "4、凡涉及或可能涉及甲方的事务，乙方在任何时候、任何事情上均不得有欺瞒甲方的行为，如有此类行为，甲方有权根据其行为的性质及产生的后果要求其承担违约责任，直至断绝一切业务关系,解除本合同。如因乙方的欺瞒行为给甲方造成损失的，甲方有权利要求乙方承担法律责任及负担经济赔偿责任。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第八条 合同不可转让")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、乙方在经营期间，除甲方书面许可外无论在任何情况下均不得转让《产品代理合同》。乙方在履行合同进程中掌握甲方的技术信息和经营信息，属商业秘密，乙方不得在任何时间以任何方式向任何人泄露同时乙方不得侵犯甲方商业秘密。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第九条 不可抗力 ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "任何一方由于不可抗力造成的部分或全部不能履行本协议书的义务的行为将不视为违约，但应在条件允许下采取一切合理及实际可行的补偿措施，以减少因不可抗力造成的损失。 "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第十条 争议解决 ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "凡因履行本协议书所发生的或与本协议书有关的一切争议，双方应首先通过有好方式协商解决，如果协商不能解决，应提请甲方所在地法院适用中华人民共和国法律诉讼解决。 "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "24pt" } }, [
      _c("strong", [_vm._v("第一条 乙方声明（以下内容需要乙方手写）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "24pt", "text-align": "justify" } },
      [
        _vm._v("3、"),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "本人承诺严格按甲方的指导价格出售产品，不得有削价或变相削价等不正当行为。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("乙方手写：")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("u")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("u")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("u")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("u")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("第十一条 附则")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、本协议经双方有权代表（理）人签字后生效；传真件具有同等法律效力。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("2、附件《故宫宣传规范》与本合同具有同等的法律效力；")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("3、本协议一式两份，双方各执一份。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("br"), _vm._v("日期： 日期： ")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("br")])
  }
]
render._withStripped = true

export { render, staticRenderFns }